import styles from "./loginwithbutton.module.css";
import ImageWithFallback from '../ImageWithFallback';

export default function LoginWithButton({ 
  iconimg, 
  iconname, 
  onClick = () => console.log("Default login button clicked") 
}) {
  return (
    <button className={styles.loginwithButton} onClick={onClick}>
      <div>
        <ImageWithFallback loading="lazy" src={iconimg} alt={iconname} />
        <p>{iconname}</p>
      </div>
    </button>
  );
}
